module.exports = __webpack_public_path__ + "static/img/x-level-4.cd6f758.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/user/x-level-4.svg
// module id = 2RN1
// module chunks = 66